export default __webpack_public_path__ + "static/media/neofin.9b382c55.png";